"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.DatagridCards = (props) => {
    return (React.createElement("div", { className: "bkn-datagrid-cards" },
        React.createElement("div", { className: "bkn-datagrid-cards-inner" }, props.children)));
};
exports.DatagridCards.displayName = 'DatagridCards';



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridCards.tsx
// module id = 244
// module chunks = 0